import {POSTHOG_UNMASK_CLASS} from '@common-web/lib/analytics';
import type {ProductConfig} from '@client/pages/public/enroll/types';

interface DeclinedNoticeProps {
  product: ProductConfig;
  onUndo: () => void;
}

export function DeclinedNotice({product, onUndo}: DeclinedNoticeProps) {
  const usesSkipWording = product.declineStyle === 'skipped';

  return (
    <div className={`flex items-center justify-between gap-4 rounded-xl border border-neutral-200 bg-white px-5 py-4 ${POSTHOG_UNMASK_CLASS}`}>
      <div>
        {usesSkipWording ? (
          <p className='font-semibold text-neutral-900'>
            You've skipped {product.label.toLowerCase()} for this year.
          </p>
        ) : (
          <>
            <p className='font-semibold text-neutral-900'>
              You've declined {product.label.toLowerCase()} coverage.
            </p>
            <p className='text-sm text-neutral-500'>You can change your mind anytime before checkout.</p>
          </>
        )}
      </div>
      <button
        type='button'
        onClick={onUndo}
        className='inline-flex h-10 shrink-0 items-center rounded-lg border border-neutral-300 px-4 text-sm font-semibold text-neutral-700 transition-colors hover:bg-neutral-50'
      >
        Undo
      </button>
    </div>
  );
}
